var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconforManifest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12477 7.31149V13.7131C8.15727 13.9568 8.07603 14.2168 7.88918 14.3874C7.81402 14.4627 7.72475 14.5224 7.62648 14.5632C7.5282 14.604 7.42285 14.625 7.31645 14.625C7.21005 14.625 7.1047 14.604 7.00642 14.5632C6.90814 14.5224 6.81887 14.4627 6.74372 14.3874L5.11082 12.7545C5.02221 12.6679 4.95484 12.5619 4.91397 12.445C4.8731 12.328 4.85984 12.2031 4.87522 12.0802V7.31149H4.85085L0.171501 1.31607C0.0395761 1.14671 -0.0199511 0.932018 0.00592682 0.718906C0.0318047 0.505794 0.140984 0.311588 0.309607 0.178725C0.463961 0.064991 0.634562 0 0.813287 0H12.1867C12.3654 0 12.536 0.064991 12.6904 0.178725C12.859 0.311588 12.9682 0.505794 12.9941 0.718906C13.0199 0.932018 12.9604 1.14671 12.8285 1.31607L8.14915 7.31149H8.12477Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconforManifest);
export default __webpack_public_path__ + "static/media/filterIconforManifest.e7dc8f1929bf123bf4d1befc20a8d145.svg";
export { ForwardRef as ReactComponent };